export default __webpack_public_path__ + "static/media/insurance-nexcaliber.411cc264.png";